import React from "react";

const PrimaryOutlineButton = ({
  label,
  className,
  onClick,
  disabled,
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`bg-[white] border-[1px] ${
        disabled
          ? "border-[#D9D9D9] text-[#D9D9D9] cursor-not-allowed"
          : "border-[#00ADEF] text-[#00ADEF]"
      } h-[40px] font-poppins ${className ? className : null}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default PrimaryOutlineButton;
